import React from "react";
import Header from "../appLayout/header";
import img from "../../assets/images/slide.png";
import "./index.scss";
export const SlidePages = ({ title, description }) => {
  return (
    <div className="slide-pages">
      <div className="header-pages pt-md-5 pt-0 ">
        <Header />
      </div>
      <div className="slide-pages-container  ">
        <div className="slide-pages-container-subtitle ">
          <img className="img-slide" src={img} alt="image" />
          +600 clients satisfaits
        </div>
        <div className="slide-pages-container-title mt-5  ">{title}</div>
        <div className="slide-pages-container-description mt-3  ">
          <div
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </div>
      </div>
    </div>
  );
};
